import intl from "../locales/index";

export function translate(language, region, key) {
  const translations = intl[`${language}-${region.toUpperCase()}`];

  if (translations) {
    return translations[key] || key;
  }

  return key;
}
